import {
  Attribute,
  Component, ElementRef, EventEmitter, Input,
  OnInit, Output
} from '@angular/core';

@Component({
  selector: 'app-input-arrow',
  templateUrl: './input-arrow.component.html',
  styleUrls: ['./input-arrow.component.css']
})
export class InputArrowComponent implements OnInit {
  @Output() inputArrow = new EventEmitter();
  @Output() cancel = new EventEmitter();
  mousedown;
  data = {
    'model': this.model,
    'operation': 'increment'
  };
  constructor(@Attribute('data-model') private model) {
  }

  ngOnInit() {

  }

  increment(event: any) {
    if (event.buttons === 2) return;
    this.mousedown = true;
    this.data.operation = 'increment';
    this.inputArrow.emit(this.data);
  }
  mousemove() {
    if (this.mousedown) {
      this.cancelEvent();
    }
  }

  decrement(event: any) {
    if (event.buttons === 2) return;
    this.mousedown = true;
    this.data.operation = 'decrement';
    this.inputArrow.emit(this.data);
  }

  cancelEvent () {
    this.mousedown = false;
    this.cancel.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/input-arrow/input-arrow.component.ts